<template>
  <ul class="course-users">
    <b-collapse animation="" :open="userRole === 'leader_admin' ? true : false" aria-id="right-users-list">
      <li @click="open" class="list_header categories" slot="trigger" aria-controls="right-users-list">
        <span class="left"> <i class="icon-button-arrow"></i>Пользователи </span>
      </li>
      <li v-for="(user, i) in usersList" :key="i" class="list_item student online">
        <router-link :to="'/users/' + user.id">
          <span class="left">
            <div
              class="student_logo"
              :style="{
                backgroundImage: user.image ? `url(${config.baseUrl + user.image})` : ''
              }"
            ></div>
            <div class="text">{{ user.surname }} {{ user.name }}</div>
          </span>
        </router-link>
      </li>
      <li v-if="usersList.length < total" class="list_item load" @click="$emit('load')">
        <span class="left">
          Загрузить ещё
        </span>
      </li>
    </b-collapse>
  </ul>
</template>

<script>
import { config } from '@/config'

export default {
  props: {
    usersList: {
      default: () => [],
      type: Array
    },
    total: {
      default: () => 0,
      type: Number
    }
  },
  methods: {
    open(e) {
      let id = e.currentTarget.attributes[0].value
      if (document.getElementById(id).attributes.length === 4) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    config() {
      return config
    }
  }
}
</script>
